import React from 'react'

type AppProps={
  data:any;
}

const GstOneTotal = ({data}:AppProps) => {

  return (
   
    <div className="col-md-12">
    <div className="gstr-one-b-head">
     <div className="total-liab h-100 gstr-one-b">  Total Liability (Outward supplies other than Reverse charge)</div>

     <div className=" h-100 gstr-one-b" style={{width:"10%"}}>
      {data?.total_taxable_value ? (+data?.total_taxable_value)?.toFixed(2) : 0}</div> 

     <div className="h-100 gstr-one-b" style={{width:"15%"}}>{data?.total_igst_amount ? (+data?.total_igst_amount)?.toFixed(2) : 0}</div>
     <div className="h-100 gstr-one-b" style={{width:"13%"}}>{data?.total_cgst_amount ? (+data?.total_cgst_amount)?.toFixed(2) : 0}</div>
     <div className="h-100 gstr-one-b" style={{width:"13%"}}>{data?.total_sgst_amount ? (+data?.total_sgst_amount)?.toFixed(2) : 0}</div>

    </div>
    </div> 
  )
}

export default GstOneTotal